import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig, DwMetaDataService, DwMetaDataServiceToken, formatDateTimeToLocal } from '@devwareapps/devware-cap';
import { DateTimeUtilService } from '../../util/date-time-util.service';

@DwComponent({
  key: 'fitness-date-time-display',
  name: 'Date Time Display',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-date-time-display-form-control',
  template: `
  <app-date-time-display-control [dateTime]="dateTimeValue"></app-date-time-display-control>
  `
})
export class DateTimeDisplayFormControlComponent implements DwFormControl, DwFormControlInit {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  context: DwContext;
  useDisplayField?: boolean;

  dateTimeValue: any;

  constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }

  initControl(): void {
    this.dateTimeValue = this.control.value;
  }

  ngOnInit() {
    this.updateValue();

    this.control.valueChanges.subscribe(value => {
      this.updateValue();
    });
  }

  private updateValue() {
    this.dateTimeValue = this.control?.value;
  }

  get control(): AbstractControl {
    return this.formGroup.get(this.fieldDef.attrName);
  }
}
